import {IAward} from 'app/models/award.d'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'
import {JsonObject} from 'utilities/types'

export class CAward extends CGraphEntity<IAward> implements IAward {
  static children = {
    notes: CNote,
  }

  program
  phase
  agency_tracking_number
  agency_name
  agency_branch_name
  business_standard_business_name
  contract
  proposal_date
  contract_end_date
  solicitation_number
  solicitation_year
  topic_code
  year
  amount
  abstract
  url

  constructor(data: IAward & JsonObject) {
    super('Award', data)
    this.program = data.program
    this.phase = data.phase
    this.agency_tracking_number = data.agency_tracking_number
    this.business_standard_business_name = data.business_standard_business_name
    this.agency_name = data.agency_name
    this.agency_branch_name = data.agency_branch_name
    this.contract = data.contract
    this.proposal_date = data.proposal_date
    this.solicitation_number = data.solicitation_number
    this.solicitation_year = data.solicitation_year
    this.contract_end_date = data.contract_end_date
    this.topic_code = data.topic_code
    this.year = data.year
    this.amount = data.amount
    this.abstract = data.abstract
    this.url = data.url
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  export() {
    return {id: this.id}
  }
}
